import instance from "../Config/authConfig"




export const generate_otp_fun = async(value)=>{
    const response = await instance.post(`${process.env.REACT_APP_BASE_URL}genrate-otp`,value)
    return response?.data
}


export const verify_user_fun = async(phone,otp)=>{
    const response = await instance.post(`${process.env.REACT_APP_BASE_URL}userverifyOtp?phone=${phone}&otp=${otp}`)
    return response.data
}
